import {defineStore} from 'pinia';
import {computed, ref, Ref} from 'vue';
import {
    IInvoiceListItem,
    IInvoicesAndPaymentReceiptsQuery,
    InvoicesAndPaymentReceiptsQuery,
} from '@/api/klip-api.proxy';
import DateUtil from '@/app/shared/helpers/date-util';
import {useKlipApiProxy} from '@/plugins/proxy-client';
import {KlAbortController} from '@/app/shared/helpers/kl-abort-controller';
import {Mri} from '@/app/mri/shared/services/services';

export const useKlInvoicesStore = defineStore('kl-invoices-store', () => {
    const klipApiProxy = useKlipApiProxy();
    const _mri_GetInvoicesAndPaymentReceipts_AbortController = new KlAbortController();


    const invoices: Ref<IInvoiceListItem[]> = ref([]);
    const fetching = ref<boolean>(true);
    const _today = DateUtil.now();
    const searchFields: Ref<Mri.IInvoicesSearchFields> = ref<Mri.IInvoicesSearchFields>({
        date: {
            from: _today.add(-1, "year").toDate(),
            to: _today.toDate()
        }
    });

    const downloadFileUri = ref<string>('');
    const unAvailable = ref<boolean>(false);

    const searchInvoices = async (userId: string, orgId: string, newSearch: Mri.IInvoicesSearchFields) => {

        if (!newSearch.date.from || !newSearch.date.to) {
            console.warn('searchInvoices: invalid arguments', newSearch);
            return;
        }

        if (newSearch.date.from?.toLocaleDateString() !== searchFields.value.date.from?.toLocaleDateString()
            || newSearch.date.to?.toLocaleDateString() !== searchFields.value.date.to?.toLocaleDateString()
            || newSearch.documentReference != searchFields.value.documentReference) {

            searchFields.value = newSearch;
            await fetchInvoices(userId, orgId);
        }
    }

    const fetchInvoices = async (userId: string, orgId: string) => {

        fetching.value = true;

        const input: IInvoicesAndPaymentReceiptsQuery = {
            fromDate: DateUtil.formatForApi(DateUtil.parseToDayJs(searchFields.value.date.from)?.startOf("day")),
            toDate: DateUtil.formatForApi(DateUtil.parseToDayJs(searchFields.value.date.to)?.startOf("day")),
            docNr: searchFields.value.documentReference,
            klipUserId: userId,
            organisationId: orgId,
        };

        const response = await klipApiProxy.mri_GetInvoicesAndPaymentReceipts(
            InvoicesAndPaymentReceiptsQuery.fromJS(input),
            _mri_GetInvoicesAndPaymentReceipts_AbortController.abortAndCreateNewSignal());

        unAvailable.value = response.result.unavailable || response.isSuccessStatusCode === false;
        downloadFileUri.value = response.result.downloadUrl;

        invoices.value = response.result.invoices.map((obj) => {
            const result = {
                ...obj,
                visible: true,
            }
            //console.log(obj.isTopUpCredit, result)
            return result;
        });

        fetching.value = false;
    };

    return {
        invoices,
        fetching,
        unAvailable,
        downloadFileUri,
        searchFields,

        fetchInvoices,
        searchInvoices,
    }
});
